import { VOUCHER_REWARD_TYPE } from "./voucher.enums";
import { z } from "zod";

// Request body for generating voucher codes (admin)
export const GenerateVoucherRequestSchema = z.object({
  rewardType: z.nativeEnum(VOUCHER_REWARD_TYPE),
  rewardAmount: z.number().int().positive(),
  expiresAt: z.coerce.date(),
});

export type GenerateVoucherRequest = z.infer<typeof GenerateVoucherRequestSchema>;

// Request body for redeeming voucher code
export const RedeemVoucherRequestSchema = z.object({
  code: z.uuid(),
});

export type RedeemVoucherRequest = z.infer<typeof RedeemVoucherRequestSchema>;

// Response for voucher details
export const VoucherResponseSchema = z.object({
  code: z.uuid(),
  rewardType: z.nativeEnum(VOUCHER_REWARD_TYPE),
  rewardAmount: z.number().int().positive(),
  redeemedAt: z.coerce.date(),
});

export type VoucherResponse = z.infer<typeof VoucherResponseSchema>;

// Response for user's redeemed vouchers
export const GetUserRedeemedVouchersResponseSchema = z.object({
  vouchers: z.array(VoucherResponseSchema),
});

export type GetUserRedeemedVouchersResponse = z.infer<typeof GetUserRedeemedVouchersResponseSchema>;
